import { NgModule } from "@angular/core";
import { TradeTypeDecisionModalComponent } from "./modals/trade-type-decision-modal/trade-type-decision-modal.component";
import { CoreModule } from "../core/core.module";
import { TradeBuyComponent } from "./modals/trade-buy-modal/trade-buy-modal.component";
import { FilterModule } from "../main/components/filters/filter.module";
import { TilesModule } from "../main/components/tiles/tiles.module";
import { TradableToViewModule } from "../main/components/tradable-to-view-item/tradable-to-view.module";
import { StepSummaryModule } from "../main/components/step-summary/step-summary.module";
import { ConfirmMandateModalComponent } from "./modals/trade-savings-modal/confirm-mandate-modal/confirm-mandate-modal.component";
import { SavingsIntermediateFirstPlanModalComponent } from "./modals/trade-savings-modal/intermediate-first-plan/savings-intermediate-first-plan-modal.component";
import { TradeSavingsComponent } from "./modals/trade-savings-modal/trade-savings-modal.component";
import { TradeSellComponent } from "./modals/trade-sell-modal/trade-sell.component";
import { TradeSwapComponent } from "./modals/trade-swap-modal/trade-swap.component";
import { TradeVoucherComponent } from "./modals/trade-voucher-modal/trade-voucher.component";
import { VerificationCommonModule } from "../main/components/verification-common/verification-common.module";
import { PayoutModule } from "../main/components/payout/payout.module";
import { StocksModule } from "../main/components/stocks/stocks.module";
import { TradableTradeSummaryComponent } from "./components/summary/tradable-trade-summary.component";
import { SavingsSummaryTradeComponent } from "./components/summary/savings-summary-trade.component";
import { Best2TermsModalComponent } from "./modals/best-2-terms-modal/components/best-2-terms-modal.component";
import { SwapTogglesComponent } from "@modules/trade/components/swap-toggles/swap-toggles.component";
import { TradeDialogComponent } from "./components/trade-dialog/trade-dialog.component";
import { DepositDialogComponent } from "./components/deposit-dialog/deposit-dialog.component";
import { TradeBuyDialogComponent } from "@modules/trade/components/trade-dialog/trade-buy-dialog.component";
import { TradeSellDialogComponent } from "@modules/trade/components/trade-dialog/trade-sell-dialog.component";
import { TradeVoucherDialogComponent } from "@modules/trade/components/trade-dialog/trade-voucher-dialog.component";
import { TradeSwapDialogComponent } from "@modules/trade/components/trade-dialog/trade-swap-dialog.component";
import { InstantTradeBonusModule } from "@modules/shared/components/instant-trade-bonus/instant-trade-bonus.module";
import { TradeNotFoundDialogComponent } from "@modules/trade/components/trade-dialog/trade-not-found-dialog.component";
import { TradeStakingDialogComponent } from "@modules/trade/components/trade-dialog/trade-staking-dialog.component";
import { TradeSavingsIntroModalComponent } from "@modules/home/components/trade-savings-intro-modal/trade-savings-intro-modal.component";
import { BannerCardModule } from "@modules/shared/banner-card-module/banner-card.module";
import { BpTableModule } from "@modules/shared/bp-table/bp-table.module";
import { BpToggleGroup } from "@modules/shared/bp-toggle-group/bp-toggle-group.module";
import { BpValueChangeModule } from "@modules/shared/bp-value-change/bp-value-change.module";
import { MatSortModule } from "@angular/material/sort";
import { BuyAgainComponent } from "@modules/trade/components/buy-again/buy-again.component";
import { BuyAssetListComponent } from "@modules/trade/components/buy-asset-list/buy-asset-list.component";
import { SellAssetListComponent } from "./components/sell-asset-list/sell-asset-list.component";
import { SavingsPlanAssetListComponent } from "./components/savings-plan-asset-list/savings-plan-asset-list.component";
import { MostPopularTradablesComponent } from "@modules/trade/components/most-popular-tradables/most-popular-tradables.component";
import { TradableChartModule } from "@modules/main/components/tradable-chart/tradable-chart.module";
import { CarouselSliderModule } from "@modules/shared/carousel-module/carousel-slider.module";
import { LeveragedTokensModule } from "@modules/main/components/leveraged-tokens/leveraged-tokens.module";
import { CashPlusFiatTileUIModule } from "@modules/cashplus/ui/cashplus-fiat-tile/cashplus-fiat-tile.module";
import { CashplusSummaryOverviewModule } from "@modules/cashplus/ui/cashplus-summary-overview/cashplus-summary-overview.module";
import { TaxWithheldSummaryUIModule } from "@modules/taxes/domain/ui/tax-withheld-summary/tax-withheld-summary.module";
import { TaxPossibleTaxableInfoLegacyUIModule } from "@modules/taxes/domain/ui/tax-possible-taxable-info-legacy/tax-possible-taxable-info-legacy.module";
import { LegacyOrderHeaderModule } from "@modules/core/components/bp-modal-header-order-variation/legacy-order-header/legacy-order-header.module";
import { BpInlineNotificationModule } from "@modules/shared/bp-inline-notification/bp-inline-notification.module";
import { SecurityTokensToggleModule } from "@modules/main/components/security-tokens/security-tokens-toggle/security-tokens-toggle.module";
import { ReactiveFormsModule } from "@angular/forms";
import { ToggleInputModule } from "@modules/shared/bp-toggle/toggle-input.module";
import { SecurityTokenUnitDisplayComponent } from "@modules/checkout/ui/security-token-unit-display/security-token-unit-display.component";
import { TermsAndConditionsUpdatesModule } from "@modules/shared/terms-and-conditions/components/terms-and-conditions-updates.module";
import { CollapsibleContainerUIComponent } from "../shared/collapsible-container/collapsible-container.component";
import { FeeTransparencyTradeDataComponent } from "@modules/checkout/ui/fee-transparency-trade-data/fee-transparency-data.component";
import { TaxInfoBoxUIComponent } from "@modules/taxes/domain/ui/tax-info-box/tax-info-box.component";
import { FeeTransparencySwapDataComponent } from "@modules/checkout/ui/fee-transparency-swap-data/fee-transparency-swap-data.component";
import { VisionOptinTogglesModule } from "@modules/web3/ui/vision-optin-toggle/vision-optin-toggle.module";
import { VisionSummaryTotalModule } from "@modules/web3/ui/vision-summary-total/vision-summary-total.module";
import { VisionSummarySwapTotalModule } from "@modules/web3/ui/vision-summary-swap-total/vision-summary-swap-total.module";
import { MtTypeSwitcherComponent } from "@modules/margin-trading/components/mt-type-switcher/mt-type-switcher.component";
import { UKFinPromModule } from "@modules/uk-finprom/ukfinprom.module";
import { RealSecuritiesBannerComponent } from "@modules/core/components/real-securities-banner/real-securities-banner.component";
import { LegacyLabelComponent } from "@modules/real-stocks/digi-sunset/legacy-label/legacy-label.component";
import { SunsetDigiBannerComponent } from "@modules/real-stocks/digi-sunset/adp-banner/sunset-digi-banner/sunset-digi-banner.component";

const components = [
	TradeTypeDecisionModalComponent,
	TradeBuyComponent,
	ConfirmMandateModalComponent,
	SavingsIntermediateFirstPlanModalComponent,
	TradeSavingsComponent,
	TradeSellComponent,
	TradeSwapComponent,
	TradeVoucherComponent,
	TradableTradeSummaryComponent,
	SavingsSummaryTradeComponent,
	Best2TermsModalComponent,
	SwapTogglesComponent,
	TradeDialogComponent,
	TradeBuyDialogComponent,
	TradeSellDialogComponent,
	TradeVoucherDialogComponent,
	TradeSwapDialogComponent,
	TradeNotFoundDialogComponent,
	TradeStakingDialogComponent,
	DepositDialogComponent,
	TradeSavingsIntroModalComponent,
	BuyAgainComponent,
	BuyAssetListComponent,
	SellAssetListComponent,
	MostPopularTradablesComponent,
	SavingsPlanAssetListComponent
];

@NgModule({
	imports: [
		CoreModule,
		TilesModule,
		TradableToViewModule,
		FilterModule,
		StepSummaryModule,
		VerificationCommonModule,
		PayoutModule,
		StocksModule,
		InstantTradeBonusModule,
		BannerCardModule,
		InstantTradeBonusModule,
		BpTableModule,
		TradableToViewModule,
		BpToggleGroup,
		BpValueChangeModule,
		MatSortModule,
		TradableChartModule,
		CarouselSliderModule,
		LeveragedTokensModule,
		CashplusSummaryOverviewModule,
		CashPlusFiatTileUIModule,
		TaxWithheldSummaryUIModule,
		TaxPossibleTaxableInfoLegacyUIModule,
		LegacyOrderHeaderModule,
		UKFinPromModule,
		BpInlineNotificationModule,
		SecurityTokensToggleModule,
		ReactiveFormsModule,
		ToggleInputModule,
		SecurityTokenUnitDisplayComponent,
		TermsAndConditionsUpdatesModule,
		CollapsibleContainerUIComponent,
		FeeTransparencyTradeDataComponent,
		TaxInfoBoxUIComponent,
		FeeTransparencySwapDataComponent,
		VisionOptinTogglesModule,
		VisionSummaryTotalModule,
		VisionSummarySwapTotalModule,
		MtTypeSwitcherComponent,
		RealSecuritiesBannerComponent,
		LegacyLabelComponent,
		SunsetDigiBannerComponent
	],
	declarations: [...components],
	exports: [...components]
})
export class TradeModule {}
